<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-row>
        <h4>{{ form.timer_log_date }}</h4>
      </b-form-row>
      <br />
      <b-form-group id="input-group-1" label="Project" label-for="input-1">
        <v-autocomplete
          filled
          clearable
          auto-select-first
          v-model="form.project_id"
          :items="projects"
          item-text="text"
          item-value="value"
          placeholder="Search project…"
          :menu-props="{maxHeight: 320}"
          required
        />
      </b-form-group>
      <br />
      <b-form-group
        id="input-group-2"
        label="Task Description"
        label-for="input-2"
      >
        <b-textarea v-model="form.task_description"> </b-textarea>
      </b-form-group>
      <br />
      <b-form-group id="input-group-3" label="hours" label-for="input-3">
        <b-input
          placeholder="Timer cannot be edited when timer is running"
          v-if="form.timer_started_at !== null"
          disabled
        >
        </b-input>
        <b-input v-model="form.hours" @change="onChangeHours" v-else> </b-input>
      </b-form-group>
      <br />
      <b-button variant="success" type="submit">Update</b-button>
      <b-button variant="secondary" @click="closeModal($event.target)"
        >Cancel
      </b-button>
      <b-button variant="danger" @click="deleteTimer()">Delete</b-button>
    </b-form>
  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import {
  convertHMSFormatInputToHours,
  displayHmFromDecimalHours,
  HHMMFormat,
} from "@/Utilites/timerHelper";
import {resolveLogBaseHours} from "@/services/timerV1Mapper";
import {removeEmptyLines} from "@/Utilites/helper";

export default {
  name: "EditTimer",
  props: ["previewItem", "modalId"],
  data() {
    return {
      form: {},
      projects: [],
    };
  },
  mounted() {
    this.loadData();
    this.loadFormFromPreview();
  },
  watch: {
    previewItem: {
      handler() {
        this.loadFormFromPreview();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["getProjectNameList", "getTimers"]),
    formValueLoaded() {
      return this.getTimers;
    },
  },
  methods: {
    ...mapActions([
      "UPDATE_TIMER_REQUEST",
      "DELETE_TIMER_REQUEST",
      "showLoadingProcess",
      "closeLoading",
    ]),
    loadData() {
      this.projects = (this.getProjectNameList || [])
        .filter((element) => element != null)
        .map((element) => ({
          value: element.id,
          text: element.project_name,
        }))
        .sort((a, b) =>
          String(a.text).localeCompare(String(b.text), undefined, {
            sensitivity: "base",
          })
        );
    },
    loadFormFromPreview() {
      if (!this.previewItem) return;
      this.form = {...this.previewItem};
      this.form.hours = displayHmFromDecimalHours(
        resolveLogBaseHours(this.form)
      );
    },
    onChangeHours(value) {
      this.form.hours = HHMMFormat(value);
    },
    async onSubmit(evt) {
      evt.preventDefault();
      await this.showLoadingProcess();
      const isRunning = this.form.timer_started_at != null;
      let parsed = resolveLogBaseHours(this.form);
      if (!isRunning) {
        // Parse the H:MM input to decimal for the API only — do NOT write the
        // decimal back onto the bound `form.hours` field, or the user briefly
        // sees "1:30" flip to "1.5" in the input while the request is in flight.
        const displayHours = HHMMFormat(this.form.hours) || this.form.hours;
        parsed = convertHMSFormatInputToHours(displayHours);
      }
      this.form.task_description = removeEmptyLines(this.form.task_description);
      this.form.log_description = this.form.task_description;
      this.form.log_date = this.form.timer_log_date;
      const timerForm = this.form;

      try {
        const toSave = {
          ...timerForm,
          hours: parsed,
          hours_with_timer: parsed,
          working_hours: parsed,
        };
        await this.UPDATE_TIMER_REQUEST({...toSave});
        this.closeModal();
        this.$emit("update-timer-function", this.form.log_date, this.getTimers);
      } catch (err) {
        console.log(JSON.stringify(err));
      } finally {
        await this.closeLoading();
      }
    },

    async deleteTimer() {
      if (confirm("Are you sure you want to delete this entry?")) {
        await this.showLoadingProcess();
        try {
          await this.DELETE_TIMER_REQUEST(this.form.id);
          this.closeModal();
          this.$emit("delete-timer-data", this.getTimers);
        } catch (err) {
          console.log(JSON.stringify(err));
        } finally {
          await this.closeLoading();
        }
      }
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
